import { render, staticRenderFns } from "./DictionaryDisciplines.vue?vue&type=template&id=c7166430&scoped=true&"
import script from "./DictionaryDisciplines.vue?vue&type=script&lang=js&"
export * from "./DictionaryDisciplines.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryDisciplines.vue?vue&type=style&index=0&id=c7166430&scoped=true&lang=scss&"
import style1 from "./DictionaryDisciplines.vue?vue&type=style&index=1&id=c7166430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7166430",
  null
  
)

export default component.exports